module.exports = __webpack_public_path__ + "de32061622d81d4b1215e342f0c46574.png";